const HEARTBEAT_ERROR_BASE = 0x0400;
export const HeartbeatErrorCodes = Object.freeze({
  /**
   * Indicates that the heartbeat service failed with Blackout DENY failure.
   */
  BLACKOUT_DENY_FAILURE: HEARTBEAT_ERROR_BASE + 0x01,
  /**
   * Indicates that the heartbeat service failed with Blackout ALLOW_WITH_UPGRADE failure.
   */
  BLACKOUT_ALLOW_UPGRADE_FAILURE: HEARTBEAT_ERROR_BASE + 0x02,
  /**
   * Indicates that the heartbeat service failed with ABORT_ROAMING failure.
   */
  HEARBEAT_ABORT_ROAMING: HEARTBEAT_ERROR_BASE + 0x03,
  /**
   * Indicates that the heartbeat service failed with ABORT_NOT_ENTITLED failure.
   */
  HEARBEAT_ABORT_NOT_ENTITLED: HEARTBEAT_ERROR_BASE + 0x04,
  /**
   *Indicates that the heartbeat service failed with ABORT_BLACKOUT failure.
   */
  HEARBEAT_ABORT_BLACKOUT: HEARTBEAT_ERROR_BASE + 0x05,
});
